import { loginPage } from './config.js';
export function gaAnalyze(str) {
    try {
        ga('send', 'event', loginPage[str], 'click');    // 谷歌统计
    } catch {}
}